import React from "react";

const ListIcon = ({ ...rest }) => (
  <svg
    {...rest}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.20941 3.01245C0.991172 3.01245 0 4.00358 0 5.22181C0 6.44005 0.991172 7.43117 2.20941 7.43117C3.42764 7.43117 4.41877 6.44005 4.41877 5.22181C4.41877 4.00358 3.42764 3.01245 2.20941 3.01245ZM2.20941 6.02492C1.76658 6.02492 1.40625 5.66464 1.40625 5.22181C1.40625 4.77898 1.76658 4.4187 2.20941 4.4187C2.65223 4.4187 3.01252 4.77898 3.01252 5.22181C3.01252 5.66464 2.65223 6.02492 2.20941 6.02492Z"
      fill="#D33479"
    />
    <path
      d="M2.20941 9.79053C0.991172 9.79053 0 10.7817 0 11.9999C0 13.2181 0.991172 14.2092 2.20941 14.2092C3.42764 14.2092 4.41877 13.2181 4.41877 11.9999C4.41877 10.7817 3.42764 9.79053 2.20941 9.79053ZM2.20941 12.803C1.76658 12.803 1.40625 12.4427 1.40625 11.9999C1.40625 11.5571 1.76658 11.1968 2.20941 11.1968C2.65223 11.1968 3.01252 11.5571 3.01252 11.9999C3.01252 12.4427 2.65223 12.803 2.20941 12.803Z"
      fill="#D33479"
    />
    <path
      d="M2.20941 16.5688C0.991172 16.5688 0 17.56 0 18.7782C0 19.9964 0.991172 20.9876 2.20941 20.9876C3.42764 20.9876 4.41877 19.9964 4.41877 18.7782C4.41877 17.56 3.42764 16.5688 2.20941 16.5688ZM2.20941 19.5813C1.76658 19.5813 1.40625 19.221 1.40625 18.7782C1.40625 18.3354 1.76658 17.9751 2.20941 17.9751C2.65223 17.9751 3.01252 18.3354 3.01252 18.7782C3.01252 19.221 2.65223 19.5813 2.20941 19.5813Z"
      fill="#D33479"
    />
    <path
      d="M8.23359 7.43117H21.7913C23.0092 7.43117 24 6.44037 24 5.22256C24 4.0032 23.0092 3.01245 21.7913 3.01245H8.23359C7.01578 3.01245 6.02499 4.00325 6.02499 5.22256C6.02499 6.44037 7.01578 7.43117 8.23359 7.43117ZM8.23359 4.4187H21.7913C22.2338 4.4187 22.5937 4.77865 22.5937 5.22106C22.5937 5.66501 22.2338 6.02492 21.7913 6.02492H8.23359C7.79119 6.02492 7.43124 5.66497 7.43124 5.22106C7.43124 4.77861 7.79119 4.4187 8.23359 4.4187Z"
      fill="#D33479"
    />
    <path
      d="M21.7914 9.79053H8.23359C7.01578 9.79053 6.02499 10.7813 6.02499 12.0006C6.02499 13.2184 7.01578 14.2092 8.23359 14.2092H21.7913C23.0092 14.2092 24 13.2184 24 12.0006C24 10.7813 23.0092 9.79053 21.7914 9.79053ZM21.7914 12.803H8.23359C7.79119 12.803 7.43124 12.443 7.43124 11.9991C7.43124 11.5567 7.79119 11.1968 8.23359 11.1968H21.7913C22.2338 11.1968 22.5937 11.5567 22.5937 11.9991C22.5938 12.4431 22.2338 12.803 21.7914 12.803Z"
      fill="#D33479"
    />
    <path
      d="M21.7914 16.5688H8.23359C7.01578 16.5688 6.02499 17.5596 6.02499 18.779C6.02499 19.9968 7.01578 20.9876 8.23359 20.9876H21.7913C23.0092 20.9876 24 19.9968 24 18.779C24 17.5596 23.0092 16.5688 21.7914 16.5688ZM21.7914 19.5813H8.23359C7.79119 19.5813 7.43124 19.2214 7.43124 18.7775C7.43124 18.3351 7.79119 17.9751 8.23359 17.9751H21.7913C22.2338 17.9751 22.5937 18.3351 22.5937 18.7775C22.5938 19.2214 22.2338 19.5813 21.7914 19.5813Z"
      fill="#D33479"
    />
  </svg>
);

export default ListIcon;
